import * as Sentry from "@sentry/react";

// 1. innitialize the store
import store from "./store/initStore";

import ConfigUtil from "./util/config/ConfigUtil";
import { currentMode } from "./util/Mode";

if(currentMode.isProd()) {
	console.log("Setting up sentry");

	Sentry.init({
		dsn: ConfigUtil.getString("sentryUri"),
		environment: ConfigUtil.getEnvName(),
		release: ConfigUtil.getVersion()
	});
}



// WEBPACK FOOTER //
// ./src/core/init.ts